const HIJRI_LOCALE = 'ar-SA-u-ca-islamic';
const HIJRI_TIMEZONE = 'Asia/Riyadh';
const PERSIAN_LOCALE = 'fa-IR-u-ca-persian';
const PERSIAN_TIMEZONE = 'Asia/Tehran';

function getPersianParts(date) {
	const parts = new Intl.DateTimeFormat(PERSIAN_LOCALE, {
		timeZone: PERSIAN_TIMEZONE,
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		numberingSystem: 'latn'
	}).formatToParts(date);

	return {
		year: Number(parts.find((part) => part.type === 'year')?.value),
		month: Number(parts.find((part) => part.type === 'month')?.value),
		day: Number(parts.find((part) => part.type === 'day')?.value)
	};
}

function formatPersianDatePart(date, options) {
	return new Intl.DateTimeFormat(PERSIAN_LOCALE, {
		timeZone: PERSIAN_TIMEZONE,
		...options
	}).format(date);
}

export function formatHijriDate(date = new Date(), options = {}) {
	const value = date instanceof Date ? date : new Date(date);

	return new Intl.DateTimeFormat(HIJRI_LOCALE, {
		timeZone: HIJRI_TIMEZONE,
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		...options
	}).format(value);
}

export function getHijriMonthDay(date = new Date()) {
	const value = date instanceof Date ? date : new Date(date);
	const parts = new Intl.DateTimeFormat(HIJRI_LOCALE, {
		timeZone: HIJRI_TIMEZONE,
		month: '2-digit',
		day: '2-digit',
		numberingSystem: 'latn'
	}).formatToParts(value);

	return {
		month: parts.find((part) => part.type === 'month')?.value ?? '',
		day: parts.find((part) => part.type === 'day')?.value ?? ''
	};
}

export default class PersianDate extends Date {
	getDate() {
		return formatPersianDatePart(this, {day: 'numeric'});
	}

	getMonth() {
		return getPersianParts(this).month - 1;
	}

	getYear() {
		return formatPersianDatePart(this, {year: 'numeric'});
	}

	getMonthName() {
		return formatPersianDatePart(this, {month: 'long'});
	}

	getDayName() {
		return formatPersianDatePart(this, {weekday: 'long'});
	}

	// Saturday = 0
	getDay() {
		const day = super.getDay();
		return day === 6 ? 0 : day + 1;
	}

	getHijriDate(options = {}) {
		return formatHijriDate(this, options);
	}
}
